const r = {
  name: "Greece",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.7878 0H13.2122L23 4.35013V8H1V4.35013L10.7878 0ZM11.2122 2L3 5.64987V6H21V5.64987L12.7878 2H11.2122Z" fill="currentColor"/>
<path d="M3 23.9V13.9H1V23.9H3Z" fill="currentColor"/>
<path d="M10.8999 23.9V13.9H8.8999V23.9H10.8999Z" fill="currentColor"/>
<path d="M15.1001 13.9V23.9H13.1001V13.9H15.1001Z" fill="currentColor"/>
<path d="M19 23.9V13.9H17V23.9H19Z" fill="currentColor"/>
<path d="M7.1001 13.9H5.1001V23.9H7.1001V13.9Z" fill="currentColor"/>
<path d="M23 24H21V14H23V24Z" fill="currentColor"/>
<path d="M23 10H1V12H23V10Z" fill="currentColor"/>
</svg>
  `
};
export {
  r as Greece
};
